export const messages = {
  required: '*Required',
  email: '*Field is not a proper email address',
  minLength: '*Field does not have enough characters',
  integer: '*Field only allows numeric values',
  maxLength: '*Field contains too many characters',
  bannerEmailRule: '*Email must be the customer\'s address',
  customerNumberExistsRule: '*Customer Number Not Found'
}
